import React from 'react';
import { Route } from 'react-router-dom';
import loadable from '@loadable/component';
import { Loadable } from 'components/Loadable';
import constants from 'Constants';
import * as paths from 'Paths';


const PromptTemplatesRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/control/prompt-templates" */
    'routes/Control/Prompts/TemplatesRoute'
  )
));

const UpdatePromptRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/control/update-prompt" */
    'routes/Extensions/Prompt/UpdatePromptRoute'
  )
));


const getControlPromptsRoutes = () => {
  return [
    {path: paths.getPathControlPromptTemplates(), component: PromptTemplatesRoute},
    {path: paths.getPathControlAddPromptTemplate(), render: (props) => <UpdatePromptRoute {...props} isTemplate={true} />},
    {path: paths.getPathControlEditPromptTemplate(":templateId"), render: (props) => <UpdatePromptRoute {...props} isTemplate={true} />},
    {path: paths.getPathControlReplicatePromptTemplate(":templateId"), render: (props) => <UpdatePromptRoute {...props} isTemplate={true} isReplicate={true} />},

  ]
}



export { getControlPromptsRoutes };
